import type React from 'react';
import type { TabbedPageComponentProps } from '../TabbedPage.config';
import { useAdManagementUserSalesforceApiHandler_getUserAndSalesProInfo } from '@zg-rentals/ts-ad-management-client-react-query';
import { Alert, Box, Paragraph, Spinner, Table } from '@zillow/constellation-10';
import { zrnNumberFormat } from '../TabbedPage.utils';

export const SalesProPage: React.FC<TabbedPageComponentProps> = () => {
  const { data: salesproData, isLoading, error } = useAdManagementUserSalesforceApiHandler_getUserAndSalesProInfo();

  if (isLoading)
    return (
      <Box css={{ display: 'flex', justifyContent: 'center' }}>
        <Spinner size="lg" />
      </Box>
    );

  if (error || !salesproData) return <Alert tone="critical">unexpected error...</Alert>;

  if (salesproData.length <= 0) return <Paragraph>Nothing to show here...</Paragraph>;

  return (
    <Table.Responsive>
      <Table.Root aria-label="sales pro table" appearance="zebra" size="md">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Account Name</Table.HeaderCell>
            <Table.HeaderCell>Account Number</Table.HeaderCell>
            <Table.HeaderCell>Sales Pro Name</Table.HeaderCell>
            <Table.HeaderCell>Sales Pro Email</Table.HeaderCell>
            {/* <Table.HeaderCell>Sales Pro Phone Number</Table.HeaderCell> */}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {salesproData.map((row) => (
            <Table.Row key={row.customerId}>
              <Table.Cell>{row.accountName}</Table.Cell>
              <Table.Cell>{zrnNumberFormat(row.customerZrn)}</Table.Cell>
              <Table.Cell>{row.salesProName}</Table.Cell>
              <Table.Cell>
                {row.salesProEmail === 'sfprodupload@zillow.com'
                  ? 'rentalfeedinquiries@zillowgroup.com'
                  : row.salesProEmail}
              </Table.Cell>
              {/* <Table.Cell>{row.salesProPhone}</Table.Cell> */}
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Table.Responsive>
  );
};
